module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "acknow"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppsorrowend0006#toc"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("California Writers Club, Bonnie DeClark, the staff of Poisoned Pen Press, Peter Goodhugh, Charles L. Juricek DVM, Ed Kaufman of M is for Mystery in San Mateo CA, Henie Lentz, Dianne Levy, Anne Maczulak, Barbara Peters of Poisoned Pen Bookstore in Scottsdale AZ, Sheldon Siegel, Luisa Smith at Book Passage in Corte Madera CA, Lyn and Michael Speakman, Meg Stiefvater, Janet Wallace.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c7a720a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-sorrowend0007.vue
// module id = 78
// module chunks = 0